import router from "@/router"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class ReservierungSelectVorbestellungLogic extends BaseLogic {
  produkteVorbestellen() {
    router.push({
      name: RouteNames.NEU.RESERVIETUNG_VORBESTELLUNG.PRODUKTE,
    })
  }

  reservierungAbschliessen() {
  }
}
